<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Inställningar - budgivning</p>
    </div>
    <div class="modal-content">
      <div>
        <select v-model="publishOption">
          <option v-for="(option, index) in availablePublishOptions" v-bind:key="index" v-bind:value="option.id">{{ option.systemAlias }}</option>
        </select>
      </div>
      <p class="all-caps mt-20 mb-10">Meddelande vid nytt bud</p>
      <div class="flex justify-between mb-30 mt-20">
        <div><label><input type="radio" class="mr-5" name="test" value="1" v-model="allowedMessagingWhenNewBid">SMS</label></div>
        <div><label><input type="radio" class="mr-5" name="test" value="2" v-model="allowedMessagingWhenNewBid">Mail</label></div>
        <div><label><input type="radio" class="mr-5" name="test" value="0" v-model="allowedMessagingWhenNewBid">Inget</label></div>
      </div>

      <div class="flex flex-column">
        <div class="mb-15">
          <label class="switch mr-10 opaque-60">
            <input type="checkbox" class="mr-5" @change="secureBidNotify" disabled v-model="secureBid">
            <div class="slider round"></div>
          </label>
          <span class="opaque-60">Säkra bud</span>
          <p class="opaque-90 fs-12 ml-50">Verifiering av budgivare måste göras på datorn.</p>
        </div>
        <div class="mb-15">
          <label class="switch mr-10">
            <input type="checkbox" class="mr-5" v-model="allowSmsBids">
            <div class="slider round"></div>
          </label>
          <span>Tillåt sms-budgivning</span>
        </div>
        <div class="mb-15 flex" v-show="allowSmsBids || secureBid">
          <label class="switch mr-10">
            <input type="checkbox" class="mr-5" v-model="confirmExternalBid">
            <div class="slider round"></div>
          </label>
          <span>Ska externa bud godkännas manuellt innan de publiceras?</span>
        </div>
      </div>

      <p class="all-caps mt-20 mb-10">Meddelandemottagare</p>
      <div class="grid2col">
        <div class="flex flex-column">
          <label class="mb-15 flex align-middle" v-for="(receiver) in defaultMessageReceivers" v-bind:key="receiver.value"><input type="checkbox" class="mr-10" v-model="tempChosenCheckboxes" v-bind:value="receiver.value">{{ receiver.alias }}</label>
        </div>
        <div class="flex flex-column">
          <label class="flex align-middle mb-15" v-for="(prio) in defaultPriorityGroups" :key="prio.alias"><input type="checkbox" :disabled="hasInterestChosen" class="mr-10" v-model="tempChosenCheckboxes" v-bind:value="prio.groupId"><span class="prio-icon flex-inline mr-5" v-bind:class="prio.class"></span><span class="prio-alias">{{ prio.alias }}</span></label>
        </div>
      </div>
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bidSettings',
  data() {
    return {
      publishOption: '',
      deliveryType: '',
      secureBid: '',
      allowedMessagingWhenNewBid: '',
      tempChosenCheckboxes : [],
      allowSmsBids: '',
      confirmExternalBid: ''
    }
  },
  created() {
    this.publishOption = this.$store.state.currentListingWithBiddings.bidSettings.policy; // policyid
    this.allowedMessagingWhenNewBid = this.$store.state.currentListingWithBiddings.bidSettings.bidSendAllowed; // messageType
    this.secureBid = this.$store.state.currentListingWithBiddings.bidSettings.secureBid; // secure
    this.tempChosenCheckboxes = this.$store.state.currentListingWithBiddings.bidSettings.bidReceiverGroupValues; // receivers
    this.allowSmsBids = this.$store.state.currentListingWithBiddings.bidSettings.bySms; // receivers
    this.confirmExternalBid = this.$store.state.currentListingWithBiddings.bidSettings.confirmExternalBid; // receivers
  },
  computed: {
    hasInterestChosen() {
      // If "intressenter" is chosen, all priority groups should be disabled
      return this.tempChosenCheckboxes.indexOf(8) !== -1;
    },
    availablePublishOptions() {
      return this.$store.state.currentListingWithBiddings.bidSettings.policyOptions;
    },
    defaultMessageReceivers: {
      get() {
        return this.$store.state.currentListingWithBiddings.bidSettings.bidReceiverStaticGroupOptions;
      }
    },
    // Prioriteringar
    defaultPriorityGroups: {
      get() {
        return this.$store.state.currentListingWithBiddings.priorityOptions;
      }
    },
  },
  methods: {
    secureBidNotify() {
      if (this.secureBid) {
        alert("Observera att kunder som ej är verifierade måste verifieras i FasAd CRM desktop version.")
      }
    },
    abort() {
      this.$root.modalOpen = false;
    },
    save() {
      let data = {
        objectId: this.$route.params.id,
        policyId: this.publishOption,
        messageType:this.allowedMessagingWhenNewBid,
        secure:this.secureBid,
        receivers: this.tempChosenCheckboxes,
        allowSmsBidding: this.allowSmsBids,
        confirmExternalBid: this.confirmExternalBid ? 1 : 0
      };

      this.$root.callFasAdApi("/internalapi/bid/save-bid-settings", "POST", data)
      .then((data) => {
        this.$root.modalOpen = false;
        this.$root.handleResponseMessage(data);
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
      })
      .catch(console.error);
    }
  }
}
</script>
<style>
.prio-alias {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:7em;
}
</style>